import { api } from './client';

// Rules API
export const rulesApi = {
  getByProject: (projectId: string) =>
    api.get<{ rules: import('../types').Rule[] }>(`/rules/project/${projectId}`),

  getById: (id: string) => api.get<{ rule: import('../types').Rule }>(`/rules/${id}`),

  create: (data: Omit<import('../types').Rule, 'id' | 'created_at' | 'updated_at'>) =>
    api.post<{ rule: import('../types').Rule }>('/rules', data),

  update: (id: string, data: Partial<import('../types').Rule>) =>
    api.patch<{ rule: import('../types').Rule }>(`/rules/${id}`, data),

  toggle: (id: string) => api.patch<{ is_active: boolean }>(`/rules/${id}/toggle`),

  delete: (id: string) => api.delete<{ message: string }>(`/rules/${id}`),

  getOptions: () =>
    api.get<{
      triggers: { type: string; label: string; config_schema: Record<string, unknown> }[];
      actions: { type: string; label: string; config_schema: Record<string, unknown> }[];
    }>('/rules/meta/options'),
};
